import { Instance, types, IMSTMap, getSnapshot, applySnapshot,  } from 'mobx-state-tree'

export const Plate = types
    .model("Plate", {
        img: types.maybeNull(types.string),
        id: types.string,
        randId: types.string,
        name: types.maybeNull(types.string),
        description: "",
        withArray: false,
        midle: 0,
        start: 0,
        end: 0,
        size: types.maybeNull(types.string),
        count: 0,
        price: 0,
        entranceNumber: 1,
        category: ""
    })

export interface IPlate extends Instance<typeof Plate> {}

export const Busket = types
    .model("Busket", {
        entrsPlates: types.array(Plate),
        goods: types.map(Plate),
        addLogo: false
    }).actions(self => ({
        addConfiguratorToBusket: (config:Array<IPlate>) => {
            config.forEach((plt, index) => {
                self.entrsPlates.push(Plate.create({
                    id:  plt.id,
                    img: plt.img,
                    randId: String(Math.round(new Date().getTime()/1000)),
                    name: plt.name,
                    withArray: false,
                    midle: 0,
                    start: 0,
                    end: 0,
                    size: plt.size,
                    count: plt.count,
                    price: plt.price,
                    entranceNumber: plt.entranceNumber,
                    category: plt.category
                }))
            })
            localStorage.setItem("busket", JSON.stringify(getSnapshot(self)) as any)
            sessionStorage.setItem("busket", JSON.stringify(getSnapshot(self)) as any)
            document.cookie = `P_REKLAMA_BUSKET=${JSON.stringify(getSnapshot(self))}; path=/; domain=.signplus.ru`
        }
    })).actions(self => ({
        swithAddLogo: () => {
            self.addLogo = !self.addLogo
            document.cookie = `P_REKLAMA_ADD_LOGO=${self.addLogo}; path=/; domain=.signplus.ru`
        }, 
        addProduct: (plate: any, count: number, start?: number, end?:number, description?: string) => {
            const randID = String(Math.round(new Date().getTime()))
            self.goods.set(randID, Plate.create({
                img: plate.img,
                id: String(plate.id),
                randId:randID,
                description: description,
                name: plate.name,
                withArray: false,
                midle: 0,
                start: start ? Number(start) : 0,
                end: end ? Number(end) : 0,
                size: plate.size,
                count: count,
                price: Number(plate.price),
                category: plate.category
            }))
            localStorage.setItem("busket", JSON.stringify(getSnapshot(self)) as any)
            sessionStorage.setItem("busket", JSON.stringify(getSnapshot(self)) as any)
            document.cookie = `P_REKLAMA_BUSKET=${JSON.stringify(getSnapshot(self))}; path=/; domain=.signplus.ru`
        },
        removeProduct: (id: string) =>{
            self.goods.delete(id)
            localStorage.setItem("busket", JSON.stringify(getSnapshot(self)) as any)
            sessionStorage.setItem("busket", JSON.stringify(getSnapshot(self)) as any)
            document.cookie = `P_REKLAMA_BUSKET=${JSON.stringify(getSnapshot(self))}; path=/; domain=.signplus.ru`
        },
        removeEntrPlates: (entNumb: number) =>{
            self.entrsPlates.forEach(item => self.entrsPlates.splice(entNumb, 1))
            localStorage.setItem("busket", JSON.stringify(getSnapshot(self)) as any)
            sessionStorage.setItem("busket", JSON.stringify(getSnapshot(self)) as any)
            document.cookie = `P_REKLAMA_BUSKET=${JSON.stringify(getSnapshot(self))}; path=/; domain=.signplus.ru`
        },
        removeAll: () =>{
            self.entrsPlates.clear()
            localStorage.clear()
        },
        removeEntrPlate: (id: string) =>{
            self.entrsPlates.find((item,index) => {
                if (item.id === id) {
                    self.entrsPlates.splice(index, 1)
                    return
                }
            })
            localStorage.setItem("busket", JSON.stringify(getSnapshot(self)) as any)
            sessionStorage.setItem("busket", JSON.stringify(getSnapshot(self)) as any)
            document.cookie = `P_REKLAMA_BUSKET=${JSON.stringify(getSnapshot(self))}; path=/; domain=.signplus.ru`
        }
    })).views(self => ({
        get getPlates(){
            let entrs = new Map
            self.entrsPlates.forEach(element => {
                entrs.set(element.entranceNumber, element) 
            });

            return entrs
        },
        get getProdictsCount() {
            return self.goods.size
        },
        get allPrice() {
            let sum: number = 0
            Array.from(self.goods.values()).forEach(item => sum = sum + item.price * item.count)
            self.entrsPlates.forEach(item => sum += item.count * item.price)
            return sum
        },
        get getGoods() {
            return Array.from(self.goods.values()).filter(it =>  !it.category)
        },
        get getNearHousePlateGoods() {
            return Array.from(self.goods.values()).filter(it =>  it.category === "nearHousePlate")
        },
        get getParkingPlateGoods() {
            return Array.from(self.goods.values()).filter(it =>  it.category === "parkingPlate")
        }
    })).views(self =>({
        get getNearHousePlateGoodsPrice() {
            let sum = 0
            self.getNearHousePlateGoods.forEach(item => sum = sum + item.count * item.price)
            return sum
        },
        get getParkingPlateGoodsPrice() {
            let sum = 0
            self.getParkingPlateGoods.forEach(item => sum = sum + item.count * item.price)
            return sum
        },
    })).actions(self => ({
        afterCreate() {
            if (localStorage.getItem("busket")) {
                applySnapshot(self, JSON.parse(localStorage.getItem("busket") || ""))
            }
            document.cookie = `P_REKLAMA_BUSKET=${JSON.stringify(getSnapshot(self))}; path=/; domain=signplus.ru`
            document.cookie = `P_REKLAMA_ADD_LOGO=${self.addLogo}; path=/; domain=.signplus.ru`
        }
    }))
